import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Utilise localStorage
import { setupListeners } from "@reduxjs/toolkit/query";

import invoiceReducer from "./invoiceSlice";
import authApi from "./auth/auth.api";
import { apiSlice } from "../services/apiSlice";
import packApi from "store/pack/pack.api";
import paymentApi from "store/payment/payment.api";
import avoirApi from "store/avoir/avoir.api";
import supplierApi from "./supplier/supplier.api";

import authReducer from "./slices/auth.slice";
import contratApi from "./contrat/contrat.api";

// 1. Combiner les reducers
const rootReducer = combineReducers({
  auth: authReducer,
  invoice: invoiceReducer,
  [authApi.reducerPath]: authApi.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [packApi.reducerPath]: packApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [avoirApi.reducerPath]: avoirApi.reducer,
  [supplierApi.reducerPath]: supplierApi.reducer,
});

// 2. Config redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Seule la slice auth est persistée
};

// 3. Appliquer persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. Configurer le store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // important pour éviter les erreurs de redux-persist
    })
      .concat(authApi.middleware)
      .concat(apiSlice.middleware)
      .concat(packApi.middleware)
      .concat(paymentApi.middleware)
      .concat(avoirApi.middleware)
      .concat(supplierApi.middleware),
});

// 5. setup listeners pour RTK Query
setupListeners(store.dispatch);

// 6. Export persistor
export const persistor = persistStore(store);
export default store;
